export default "__VITE_ASSET__CfHHagGR__"